module.exports = __webpack_public_path__ + "img/w_brochure.3a42650b.svg";